import { AxiosError } from "axios";
import { useMutation, useQuery } from "react-query";
import { useErrorHandler } from "../../../../../hooks/useErrorHandler";
import {
  addStockHistory,
  getStockHistory,
  Http_GET_StockHistory,
} from "./service";
import { Form_Create_Stock } from "../../../form/FormStockAdjusment";
import useSuccessHandler from "../../../../../hooks/useSuccessHandler";

export const useGetStockHistory = ({
  product_id,
  keyword,
  page,
  perPage,
}: Http_GET_StockHistory) => {
  const { redirectOnTokenExpired } = useErrorHandler();

  return useQuery({
    enabled: product_id !== undefined,
    queryKey: `produkStockHistory`,
    queryFn: () => getStockHistory({ product_id, keyword, page, perPage }),
    onError: (e: AxiosError) => redirectOnTokenExpired(e),
  });
};

export const useAddStockHistory = () => {
  const { showToastOnError } = useErrorHandler();
  const { showToast } = useSuccessHandler();

  return useMutation({
    mutationKey: `addHistoryStock`,
    mutationFn: ({ description, product_id, quantity }: Form_Create_Stock) =>
      addStockHistory({ description, product_id, quantity }),
    onSuccess: (e) => showToast("Berhasil menambahkan stock produk baru"),
    onError: (e: AxiosError) => showToastOnError(e),
  });
};
